import { Tab as MuiTab } from '@mui/material';
import { ComponentProps, PropsWithChildren } from 'react';
import {
  TabContext,
  TabList,
  TabPanel as MuiTabPanel,
  TabPanelProps,
  TabContextProps,
} from '@mui/lab';
import { Link } from 'react-router-dom';
import { useHeaderTabStyles } from './styles';

type TabProps = ComponentProps<typeof MuiTab> & { to?: string };

const Tab = ({ to, ...props }: TabProps) => {
  return <MuiTab {...props} component={to ? Link : props.LinkComponent!} to={to} />;
};

const List = ({ children, ...props }: PropsWithChildren<ComponentProps<typeof TabList>>) => {
  return (
    <TabList {...props} orientation='horizontal'>
      {children}
    </TabList>
  );
};

const TabPanel = ({ ...props }: TabPanelProps) => {
  const classes = useHeaderTabStyles();
  return <MuiTabPanel {...props} classes={{ root: classes.tabPanelRoot }} />;
};

type Namespace = { Tab: typeof Tab; List: typeof List; TabPanel: typeof TabPanel };

const Root = ((props: TabContextProps) => (
  <TabContext value={props.value}>{props.children}</TabContext>
)) as typeof TabContext & Namespace;

Root.Tab = Tab;
Root.List = List;
Root.TabPanel = TabPanel;

export const HeaderTabs = Root;
